import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: document.querySelector('meta[name="sentry-dsn"]')?.content,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})
